import { Grid } from "@material-ui/core";
import { useEffect } from "react";
import useValidations from "../../../hooks/useValidations";
import { lang } from "../../../i18nLang";
import ColumnField from "../ColumnField";
import { ColumnControl, RedText, Title } from "./styles";

interface TabColumnProps {
  /** Array com os nomes das propriedades obrigatórias. */
  fields: string[];
  /** Objeto com as colunas referentes as propriedades obrigatórias. */
  values: {};
  /** Função chamada ao alterar o valor de uma ColumnField. */
  onChange: (name: string, value: string) => void;
  /** Função chamada ao alterar o objeto de erros dos campos. */
  onChangeErrors?: Function;
  /** Objeto com as validações para cada propriedade obrigatórias */
  validations: {};
}

/** Formulário para definir as propriedades obrigatórias para importação de contrato.
 * @category Components
 */
const TabColumns = (props: TabColumnProps) => {
  const { validated, validateFields } = useValidations(props.validations);

  useEffect(() => {
    const hasErrors = !validateFields(props.values, true);
    if (props.onChangeErrors) {
      props.onChangeErrors(hasErrors);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBlur = (event) => {
    const { name, value } = event.target;
    const hasErrors = !validateFields({ [name]: value });
    if (props.onChangeErrors) {
      props.onChangeErrors(hasErrors);
    }
  };

  return (
    <>
      <Title>{lang(`importation.modeFile.subtitle3`)}</Title>
      {props.fields.map((field) => {
        const label = lang(`fields.${field}`) || field;
        const value = props.values[field];
        const fieldValidated = validated[field];

        return (
          <ColumnControl key={field} container justifyContent="center">
            <Grid container item xs={6} md={5} alignItems="center">
              {label}
              <RedText>*</RedText>
            </Grid>
            <Grid container item xs={6} md={5} alignItems="center">
              <ColumnField
                name={field}
                value={value}
                disabled={false}
                onChange={props.onChange}
                inputProps={{
                  onBlur: handleBlur,
                  error: !fieldValidated ? false : !fieldValidated.valid,
                  helperText: fieldValidated?.text,
                }}
              />
            </Grid>
          </ColumnControl>
        );
      })}
    </>
  );
};

export default TabColumns;
